import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBoxProps {
  initialValue?: string;
  placeholder?: string;
  size?: 'md' | 'lg';
}

export default function SearchBox({
  initialValue = '',
  placeholder = '搜索电影、电视剧或演员…',
  size = 'md',
}: SearchBoxProps) {
  const [value, setValue] = useState(initialValue);
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const keyword = value.trim();
    if (!keyword) return;
    navigate(`/search?q=${encodeURIComponent(keyword)}`);
  };

  const heightClass = size === 'lg' ? 'h-12' : 'h-10';

  return (
    <form onSubmit={handleSubmit} role="search" className="w-full">
      <div
        className={`flex ${heightClass} w-full items-center gap-2 rounded-full border border-background-300 bg-background-100 pl-4 pr-1 transition-colors focus-within:border-primary-400`}
      >
        <i className="ri-search-line text-lg text-foreground-500" aria-hidden="true" />
        <input
          type="search"
          name="q"
          value={value}
          onChange={(event) => setValue(event.target.value)}
          placeholder={placeholder}
          aria-label="影视搜索"
          className="h-full min-w-0 flex-1 bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
        />
        <button
          type="submit"
          className={`h-8 flex-shrink-0 whitespace-nowrap rounded-full bg-primary-500 px-4 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer`}
        >
          搜索
        </button>
      </div>
    </form>
  );
}